import { render, staticRenderFns } from "./DetalhesFracassados.vue?vue&type=template&id=6c8f5e30&scoped=true"
import script from "./DetalhesFracassados.vue?vue&type=script&lang=ts"
export * from "./DetalhesFracassados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f5e30",
  null
  
)

export default component.exports